import React from "react";
import Modal from "components/BaseWidgets/modal";
import Button from "components/BaseWidgets/button";
import { CloseIconPrimary } from "assets/icons";

const NotInterestedModal = ({
  isOpen,
  onCancel,
  onConfirm,
  title = "Are you sure?",
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary", // default button color
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onCancel={onCancel}
      onOk={onConfirm}
      title={title}
      footer={null}
      closable
      closeIcon={<CloseIconPrimary />}
      width={440}
    >
      <div className="font-body-large">{description}</div>
      <div className="flex justify-end gap-2 mt-4">
        <Button
          className="modal-buttons"
          variant="secondary"
          height={44}
          onClick={onCancel}
        >
          {cancelText}
        </Button>
        <Button
          className="modal-buttons"
          variant={confirmVariant}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
};

export default NotInterestedModal;
